var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19046_7339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92969 20.4004C7.2915 21.2324 7.88843 21.9405 8.64716 22.438C9.40589 22.9354 10.2934 23.2003 11.2006 23.2003C12.1079 23.2003 12.9953 22.9354 13.7541 22.438C14.5128 21.9405 15.1097 21.2324 15.4716 20.4004H6.92969Z",
    fill: "#A7A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8975 12.5128L19.2772 7.17136C18.7583 5.30315 17.6302 3.66181 16.072 2.50796C14.5138 1.3541 12.6148 0.753866 10.6764 0.802549C8.73813 0.851232 6.87163 1.54604 5.3733 2.77667C3.87496 4.00729 2.83068 5.70319 2.40626 7.59509L1.14813 12.763C0.980903 13.4497 0.971843 14.1654 1.12163 14.8561C1.27141 15.5468 1.57613 16.1945 2.01279 16.7502C2.44944 17.306 3.00662 17.7553 3.64229 18.0643C4.27795 18.3732 4.97549 18.5338 5.68226 18.5338H16.4315C17.1601 18.5338 17.8787 18.3632 18.5296 18.0356C19.1805 17.708 19.7456 17.2325 20.1798 16.6473C20.6139 16.062 20.9049 15.3832 21.0295 14.6653C21.1542 13.9473 21.1089 13.2102 20.8975 12.5128Z",
    fill: "#A7A7A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19046_7339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 22.4,
    fill: "white",
    transform: "translate(0 0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.f51efdc9eb8e6fd404e50a33a163ad09.svg";
export { ForwardRef as ReactComponent };